/**
 * Federal multi-state Regions 1–10 used by the Location filter Region selector.
 * Do not reuse Vendors map region groupings (Northeast, etc.) — those differ.
 *
 * Compact tuples keep structural duplication low for Sonar; expand at module load.
 */

const REGION_DEFS = [
  [
    'region_1',
    'Region 1 (New England)',
    'CT:Connecticut|ME:Maine|MA:Massachusetts|NH:New Hampshire|RI:Rhode Island|VT:Vermont',
  ],
  ['region_2', 'Region 2 (Northeast and Caribbean)', 'NJ:New Jersey|NY:New York|PR:Puerto Rico|VI:Virgin Islands'],
  [
    'region_3',
    'Region 3 (Mid-Atlantic)',
    'DC:District Of Columbia|DE:Delaware|MD:Maryland|PA:Pennsylvania|VA:Virginia|WV:West Virginia',
  ],
  [
    'region_4',
    'Region 4 (Southeast)',
    'AL:Alabama|FL:Florida|GA:Georgia|KY:Kentucky|MS:Mississippi|NC:North Carolina|SC:South Carolina|TN:Tennessee',
  ],
  ['region_5', 'Region 5 (Great Lakes)', 'IL:Illinois|IN:Indiana|MI:Michigan|MN:Minnesota|OH:Ohio|WI:Wisconsin'],
  ['region_6', 'Region 6 (South Central)', 'AR:Arkansas|LA:Louisiana|NM:New Mexico|OK:Oklahoma|TX:Texas'],
  ['region_7', 'Region 7 (Great Plains)', 'IA:Iowa|KS:Kansas|MO:Missouri|NE:Nebraska'],
  [
    'region_8',
    'Region 8 (Mountains and Plains)',
    'CO:Colorado|MT:Montana|ND:North Dakota|SD:South Dakota|UT:Utah|WY:Wyoming',
  ],
  [
    'region_9',
    'Region 9 (Pacific Southwest)',
    'AZ:Arizona|CA:California|HI:Hawaii|NV:Nevada|AS:American Samoa|GU:Guam|MP:Northern Mariana Islands',
  ],
  ['region_10', 'Region 10 (Pacific Northwest)', 'AK:Alaska|ID:Idaho|OR:Oregon|WA:Washington'],
];

const parseStates = (encoded) =>
  encoded.split('|').map((pair) => {
    const separator = pair.indexOf(':');
    return {
      code: pair.slice(0, separator),
      name: pair.slice(separator + 1),
    };
  });

export const US_REGIONS = REGION_DEFS.map(([id, label, states]) => ({
  id,
  label,
  states: parseStates(states),
}));

/** Map of state code (uppercase) → region id */
export const STATE_CODE_TO_REGION_ID = US_REGIONS.reduce((acc, region) => {
  region.states.forEach((state) => {
    acc[state.code.toUpperCase()] = region.id;
  });
  return acc;
}, {});

export const US_REGIONS_BY_ID = US_REGIONS.reduce((acc, region) => {
  acc[region.id] = region;
  return acc;
}, {});
